import { DateTime } from 'luxon';

const toStockholmTime = (date: string | DateTime): DateTime => (
  date instanceof DateTime
    ? date.setZone('Europe/Stockholm')
    : DateTime.fromISO(date).setZone('Europe/Stockholm')
);

export default toStockholmTime;
